export enum HttpStatusCode {
  OK = 200,
  Created = 201,
  NoContent = 204,
  BadRequest = 400,
  UnAuthorized = 401,
  NotFound = 404,
  InternalServer = 500,
  ServiceUnavailable = 503
}


// WEBPACK FOOTER //
// ./src/common/enums/http-status-code-enum.ts